import React,{ useContext, useEffect, useState } from 'react';
import AuthContext from '../../context/authContext/authContext';
import MuiAlert from '@material-ui/lab/Alert';
import Layout from './Layout';
import VerPëdido from './VerPedido';
import {
    Grid,
    // Box,  
    // Button,
    Backdrop,
    CircularProgress, 
    makeStyles,
    Snackbar,
    // Typography,
    
   
} from '@material-ui/core';
import GenerarPedido from './nuevoPedido/GenerarPedido';

//ESTILOS
const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
      },
}));
//ALERTA
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }


const Cliente = (props) => {
    //EXTRAER CONTEXT
    const authContext = useContext(AuthContext);
    const {
        getCarrito,
        cliente,
        autenticado,
        pedido,
        getPedidoCliente,
        eliminarPedido,
        reiniciarErrorMensaje,
        mensaje
        } = authContext; 
    
    const [activeComponente, setactiveComponente] = useState("cliente");    
    const [isloading, setisloading] = useState(false);
    //CARGA ESTILOS
    const classes = useStyles();
    //CICLO COMPONENTE
    useEffect(() => {
        
        if(cliente){
            getCarrito(cliente)
            getPedidoCliente(cliente)
            if(cliente.admin === 'true'){
                props.history.push('/admin')
            }
        }
        
       // eslint-disable-next-line
    }, [autenticado]);
    
    // const nuevoPedido = () =>{
    //     setactiveComponente("GenerarPedido")
       
    // }
    const handleClose = () => {
        reiniciarErrorMensaje()
    }
   
    

    return (
      <>
        <Backdrop className={classes.backdrop} open={isloading} >
            <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar open={mensaje ? true : false} autoHideDuration={3000} 
                        onClose={handleClose}
                        anchorOrigin={ {vertical: 'top', horizontal: 'center'} }>
                <Alert onClose={handleClose} severity="success">
                    {mensaje}
                </Alert>
        </Snackbar>
        <Layout history={props.history} title = 'Servicio deshabilitado' cliente = {true}>
        {activeComponente === "cliente" ? <><Grid container>
            {/* <Grid item xs={6} >
                <Box mt={5} mr={1} style={{
                    textAlign : 'right'
                      }}>
                    <Button variant="contained" color="primary" onClick={nuevoPedido} disabled={pedido !== null}>
                       {pedido !== null ? "Ya hay un pedido en curso"  : "Realiza tu Pedido"}
                    </Button>
                </Box>
            </Grid>
            <Grid item xs={6} >
                <Box mt={5} ml={2} mb={5} style={{
                    textAlign : 'left'
                }}>
                    <Button variant="contained" disabled >
                        Reserva tu mesa
                    </Button>
                </Box>
            </Grid> */}
            
        </Grid>
        {pedido ? <VerPëdido pedido={pedido} cliente={cliente} eliminarPedido={eliminarPedido} setisloading={setisloading}/> : null  }
        
        </>
        : null}
        {activeComponente === "GenerarPedido" ? <GenerarPedido props={props} setactiveComponente={setactiveComponente} /> : null }
        </Layout>
        
      
        </>
    );
}
 
export default Cliente;